import { useMemo } from "react";

import { useCompiledCells } from "~/state";

export const useComputeCells = (documentId: string, pageId: string) => {
	const compiledCells = useCompiledCells(documentId, pageId);
	return useMemo(() => {
		const cellNames = new Set(
			Object.values(compiledCells ?? {}).map(({ cell }) => cell.cellName)
		);
		return {
			compiledCells: compiledCells ?? {},
			makeUniqueCellName: (nameTemplate: string, disallowed: string[] | Set<string> = []) => {
				const disallowedNames = new Set(disallowed).union(cellNames);

				// IMPORTANT: If we are pasting a cell, we don't want to change the name unless we
				// have to. This is especially important when pasting many cells, which often depend
				// on each other. We'd have to rewrite all the references to the cell name.
				if (!disallowedNames.has(nameTemplate)) {
					return nameTemplate;
				}

				let i = 0;
				let cellName = `${nameTemplate}${i}`;
				while (disallowedNames.has(cellName)) {
					cellName = `${nameTemplate}${i++}`;
				}
				return cellName;
			},
		};
	}, [compiledCells]);
};
